import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  @media (max-width: 650px) {
    background-color: ${({ theme }) => theme.colors.namedColors.white};
    align-items: stretch;
    width: 100%;
  }
`;

export const BlockWrapper = styled.div`
  padding: 4rem;
  max-width: 60rem;
  width: 100%;
  border-radius: 3rem;
  border: 1px solid #dcdde0;
  background-color: ${({ theme }) => theme.colors.namedColors.white};
  display: flex;
  flex-direction: column;
  gap: 3.2rem 0;

  @media (max-width: 650px) {
    border-radius: 0;
    padding: 2.4rem 1.6rem;
    flex: 1;
    min-height: 100%;
  }
`;

export const ContinentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
`;

export const ContinentHeader = styled.h2`
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 2.2rem;
  letter-spacing: 0.05rem;
`;

export const CountriesContainer = styled.div`
  display: flex;

  margin-bottom: 3.2rem;
  gap: 2.4rem;

  @media (max-width: 650px) {
    flex-direction: column;
  }
`;

export const BlockWrapperTopContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem 0;
`;

export const BlockWrapperBottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3.2rem 0;

  @media (max-width: 650px) {
    justify-content: space-between;
    flex-grow: 1;
  }
`;

export const WelcomeTitle = styled.h1`
  text-align: center;
  position: relative;
  font-size: 2.6rem;
  line-height: 4rem;

  svg {
    transform: translate(-6px, 5px);
  }
`;

export const WelcomeExcerpt = styled.p`
  text-align: center;
  position: relative;
  font-size: 1.4rem;
  line-height: 2rem;
  color: ${({ theme }) => theme.colors.baseColors.grey150};
`;

export const CountryInfo = styled.span`
  display: flex;
  cursor: pointer;
  align-items: center;
  border-radius: 1.6rem;
  border: 1px solid ${({ theme }) => theme.colors.baseColors.grey50};
  padding: 1.2rem 1.6rem 1.2rem 2.4rem;
  width: 25.1rem;
  min-height: 7.2rem;
  gap: 1.6rem;
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 2.2rem;
  letter-spacing: 0.05rem;
  color: ${({ theme }) => theme.colors.baseColors.grey150};

  &:hover {
    background: ${({ theme }) => theme.colors.baseColors.grey5};
    transition-property: border-color, background-color, color, outline-color;
    transition-duration: 0.2s;
  }

  @media (max-width: 650px) {
    width: 100%;
    min-height: 5.6rem;
    padding: 0.8rem 1.2rem;
    border-radius: 1rem;
  }
`;

export const CountryImage = styled.img`
  background-repeat: no-repeat;
  background-size: cover;
  min-width: 3.4rem;
  min-height: 2.4rem;
`;
